var t=9,E=3,N=9;export{N as DECIMAL_UNITS,E as DEFAULT_MIN_PRECISION,t as DEFAULT_PRECISION};
//# sourceMappingURL=configs.mjs.map